import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  MenuItem,
  Select,
} from '@mui/material'
import { useState } from 'react'

// Placeholder data — replace with real Netsuite items when available
const NETSUITE_VENDOR_OPTIONS = ['Netsuite Item 1', 'Netsuite Item 2', 'Netsuite Item 3']

export interface SelectNetsuiteVendorDialogProps {
  open: boolean
  onCancel: () => void
  onProceed: (vendor: string) => void
}

export function SelectNetsuiteVendorDialog({ open, onCancel, onProceed }: SelectNetsuiteVendorDialogProps) {
  const [selectedVendor, setSelectedVendor] = useState('')

  const handleCancel = () => {
    setSelectedVendor('')
    onCancel()
  }

  const handleProceed = () => {
    if (!selectedVendor) return
    const vendor = selectedVendor
    setSelectedVendor('')
    onProceed(vendor)
  }

  return (
    <Dialog open={open} onClose={handleCancel} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontWeight: 600 }}>Select Default Netsuite Vendor</DialogTitle>

      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <DialogContentText>
          A default Netsuite vendor must be selected before this supplier can be approved.
        </DialogContentText>

        <FormControl fullWidth size="small">
          <Select
            displayEmpty
            value={selectedVendor}
            onChange={e => setSelectedVendor(e.target.value)}
            renderValue={value => (value ? value : 'Default Netsuite Vendor')}
            sx={{ color: selectedVendor ? 'inherit' : 'text.secondary' }}
          >
            {NETSUITE_VENDOR_OPTIONS.map(option => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button variant="outlined" onClick={handleCancel}>
          CANCEL
        </Button>
        <Button variant="contained" onClick={handleProceed} disabled={!selectedVendor}>
          PROCEED
        </Button>
      </DialogActions>
    </Dialog>
  )
}
